import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@app/services/auth/auth.service';
import { NAV_LINKS } from '@app/utils/constants/nav-links.constants';
import { AppRoutes } from '@app/utils/enums/routes.enum';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-nav',
  standalone: true,
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  imports: [RouterModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavComponent {
  public readonly navLinks = NAV_LINKS;
  public readonly appRoutes = AppRoutes;
  protected readonly isLoggedIn = inject(AuthService).isLoggedIn;
}
